// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b89d6337","801":"ae41afd1"}[chunkId] + ".chunk.js";
};